import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyMediaQueryService } from './media-query.service';


export class SkyMediaQueryModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  providers: [
    SkyMediaQueryService
  ],
  imports: [
    CommonModule
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
